import RecipeDetails from '../components/RecipeDetails';

function DrinksDetails() {
  return (
    <RecipeDetails />
  );
}

export default DrinksDetails;
